var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketApproval = function SvgTicketApproval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#44AC21",
    d: "M7 13.125A6.125 6.125 0 1 1 7 .875a6.125 6.125 0 0 1 0 12.25M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#44AC21",
    d: "m9.598 4.348-.017.02L6.543 8.24 4.71 6.408a.656.656 0 0 0-.928.928l2.315 2.316a.656.656 0 0 0 .945-.018l3.493-4.367a.656.656 0 0 0-.938-.919"
  })));
};
export default SvgTicketApproval;